import React from "react";
import AppStore from "../../assets/icons/Apple.svg";
import AppStoreLight from "../../assets/icons/Apple-light.svg";
import Button from "../Button";
/**
 *
 * @param {string} theme Choose a theme between dark and light
 * @param {number} height Controls the height of the button
 * @param {number} width Controls the width of the button
 * @param {string} title Set custom title for the button
 * @param {string} className Add className to the button in order to customize the button appearance
 * @param {string} url Add your store url to the button
 * @example <AppStoreButton theme="light" height={70} width={130} className="button-container" url="https://www.apple.com/app-store/" />
 * @returns
 */
var AppStoreButton = function AppStoreButton(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? "light" : _ref$theme,
    height = _ref.height,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? "Download on the" : _ref$title,
    width = _ref.width,
    className = _ref.className,
    url = _ref.url;
  return /*#__PURE__*/React.createElement(Button, {
    theme: theme,
    height: height,
    width: width,
    url: url,
    storeName: "App Store",
    logo: theme === "dark" ? AppStoreLight : AppStore,
    className: className,
    title: title
  });
};
export default AppStoreButton;